import React, { useState } from "react";
import "./information.scss";
import Input from "../../../components/input";
import Button from "../../../components/button";
import Changepassword from "../../../components/modal/changepassword";
import { getUser, setUser } from "../../../helpers/utils/auth.util";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../../store/slices/authSlice";
import toast from "react-hot-toast";

export default function Information() {
  const dispatch = useDispatch();
  const { authLoader } = useSelector((state) => state.auth);
  const user = getUser();
  const [userInfo, setUserInfo] = useState(user);
  const [changePasswordModel, setChangePasswordModel] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setUserInfo({ ...userInfo, [name]: value });
  };

  const handleSubmit = async () => {
    if (!userInfo?.name?.trim()) {
      toast.error("Name is required");
      return;
    }

    const result = await dispatch(updateUser({
      name: userInfo.name,
      openai_api_key: userInfo.openai_api_key,
    }));

    if (result?.payload?.data?.success) {
      toast.success("Profile updated successfully!");
      setUser(result.payload.data.data);
    } else {
      toast.error(result?.payload?.data?.message || "Failed to update profile");
    }
  };

  return (
    <div>
      <div className="container">
        <div className="setting-information-content-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="card-header">
                <span>Personal Information</span>
              </div>
              <div className="card-body">
                <Input
                  label="Full Name"
                  name={"name"}
                  placeholder={userInfo?.name}
                  value={userInfo?.name}
                  onChange={handleOnChange}
                />
                <div className="save-button">
                  <Button
                    text="Save Changes"
                    onClick={handleSubmit}
                    loader={authLoader}
                  />
                </div>
              </div>
            </div>
            <div className="grid-items">
              <div className="card-header">
                <span>Account Information</span>
              </div>
              <div className="card-body">
                <Input
                  label="Email"
                  placeholder={userInfo?.email}
                  value={userInfo?.email}
                  name={"email"}
                  disabled={true}
                />
                <div
                  className="change-password"
                  onClick={() => setChangePasswordModel(true)}
                >
                  <Link>Change password</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="grid-items">
              <div className="card-header">
                <span>OpenAI Configuration</span>
              </div>
              <div className="card-body">
                <Input
                  label="OpenAI API Key"
                  placeholder="sk-..."
                  value={userInfo?.openai_api_key}
                  name={"openai_api_key"}
                  type="password"
                  onChange={handleOnChange}
                />
                <div style={{ marginTop: '15px' }}>
                  <Button
                    text="Save Key"
                    onClick={handleSubmit}
                    loader={authLoader}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {changePasswordModel && (
        <Changepassword
          changePasswordModel={changePasswordModel}
          setChangePasswordModel={setChangePasswordModel}
        />
      )}
    </div>
  );
}

